/* eslint-disable eqeqeq */
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import signinApi from '../apis/auth/signinApi';
import routerLinks from '../components/app/routerLinks';
import UserContext from '../contexts/user-context/UserProvider';
import errorNotification from '../utils/errorNotification';
import successNotification from '../utils/successNotification';
import useCustomApiRequest from './useCustomApiRequest';

const useSigninEmailPassword = () => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  const { setCurrentUser, setUserToState } = useContext(UserContext);
  const customApiRequest = useCustomApiRequest();
  const [isLoadingSignin, setIsLoadingSignin] = React.useState(false);
  const signMeInWithEmailPassword = (data) => {
    setIsLoadingSignin(true);
    customApiRequest(
      signinApi(
        {
          ...data
        },
        i18n.language
      ),
      (res) => {
        setIsLoadingSignin(false);
        if (res?.data?.status === 1) {
            if (res?.data?.data?.status === 3) {
            errorNotification({
              title: 'حسابك مغلق',
              message: 'من فضلك تواصل معنا لاعادة فتح الحساب'
            });
          }
          else {
             successNotification({
              title: t('successTitle'),
              message: 'ادخل الكود المرسل الى رقم جوالك'
            });
            setUserToState({
              ...res?.data.data,
              accountType: data?.accountType || res.data.data.type,
              activated: false
            });
            navigate(routerLinks?.activateAccountRoute);
          }
        } else {
          errorNotification({
            title: t('errorTitle'),
            message: res?.data?.message || 'البيانات المدخلة غير صحيحة'
          });
        }
      },

      (error) => {
        setIsLoadingSignin(false);
        errorNotification({
          title: 'حدث خطأ اثناء تسجيل الدخول',
          message: error?.response?.data?.message || 'من فضلك حاول وقت لاحق'
        });
      }
    );
  };

  return { signMeInWithEmailPassword, isLoadingSignin, setIsLoadingSignin };
};

export default useSigninEmailPassword;
